import { render, staticRenderFns } from "./assessmentRecordLevel2Table.vue?vue&type=template&id=6f0a495d&scoped=true&"
import script from "./assessmentRecordLevel2Table.vue?vue&type=script&lang=js&"
export * from "./assessmentRecordLevel2Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0a495d",
  null
  
)

export default component.exports